import React, { SetStateAction, useEffect, useState, useMemo } from "react"
import {
  Box,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Typography,
  Input,
  Slider,
  OutlinedInput,
  Chip,
  Stepper,
  StepLabel,
  Step,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material"
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import dayjs from 'dayjs';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InputAdornment from '@mui/material/InputAdornment';
import { DemoItem } from "@mui/x-date-pickers/internals/demo"
import * as Style from "./style"
import minusImg from "../../images/minus-fill.svg"
import PinkMinusImg from "../../images/pink-minus-fill.svg"
import plusImg from "../../images/plus-fill.svg"
import { useGetJobServiceQuery, useNotifySpecialNeedsMutation, useGetAcceptedGeneratedPostsAllQuery } from "../../features/OverViewAuth/overViewApi"

import { checkBookingConflict } from "../../utils/bookingValidation"
import { toast } from "react-toastify"
import { Controller, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useAppSelector } from "../../app/hooks"
import { useAppDispatch } from "../../app/store"
import { languages } from "../Languagejson/language"
import CenteredSpinner from "../common/CenteredSpinner"
import FileUpload from "../common/multipleImage"
import LocationSelector from "./SearchLocation"
import { Payload } from "./postInterFace"
import { setBookingDetails } from "../../features/PostCreat/postcreateSlice"
import moment from "moment"
import { FaChevronLeft } from "react-icons/fa"
import ServiceFieldRenderer from "../Booking-Form/booking-form"
import LivePriceCalculator from "../Booking-Form/LivePriceCalculator"
import {
  fieldsConfig, ServiceType, serviceTypeMapping, validateServiceFields as validateServiceFieldsExternal,  // Rename here
  getServiceValidationSchema, validateSingleField
} from "../Booking-Form/fieldsConfig"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { commonTerms, serviceTermsConfig } from "../Booking-Form/termsConfig"
import { createLocalDateTime, getLocalDateString, isSameLocalDay, formatToLocalWithOffset, getLocalTimeString } from "../../utils/LocalDate"

const steps = ["Booking Summary", "Payment", "Request Sent"]

function slidertext(value: number) {
  return `${value}`
}

interface createBooking {
  date: string
}

interface fileData {
  url: string
  file: File
}

interface ErrorProps {
  startOnTimer: string | undefined
  selectLocation: string | undefined
  selectLanguage: string | undefined
  selectServiceError: string | undefined
  additionalInfo: string
  // photos: string 
}

const CreateBooking = () => {
  const [slidervalue, sliderSetValue] = React.useState<number[]>([18, 45])
  const [count, setCount] = React.useState<number>(1)
  const [hoursSend, setHoursSend] = useState<number>(2)
  const [errorMsg, setErrorMsg] = useState<ErrorProps>({
    startOnTimer: "",
    selectLocation: "",
    selectLanguage: "",
    selectServiceError: "",
    additionalInfo: "",
    // photos: "",
  })
  const [priceData, setPriceData] = useState()
  const [taxData, setTaxData] = useState()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [selectedDate, setSelectedDate] = useState("")
  const [selectedStartTime, setSelectedStartTime] = useState("")
  const [selectedEndTime, setSelectedEndTime] = useState("")
  const [startTimeOptions, setStartTimeOptions] = useState([])
  const [endTimeOptions, setEndTimeOptions] = useState([])
  const [endTimeShow, setEndTimeShow] = useState("")
  const [searchParams, setSearchParams] = useSearchParams()
  const [arrayImages, setArrayImages] = useState<fileData[]>([])
  const [val, setVal] = useState("")
  const [loactionSearchData, setLocationSearchData] = useState<string>("")
  const [typeadditionalInfo, setTypeAdditionalInfo] = useState<string>("")
  const [minusImage, setMinusImage] = useState(minusImg)
  const [minusImagehour, setMinusImagehour] = useState(minusImg)
  const [isNextDay, setIsNextDay] = useState(false)
  const [bookingDetailsShow, setBookingDetailsShow] = useState(false)
  const [isServiceProviderFixed, setIsServiceProviderFixed] = useState(false);
  const showDetails = searchParams.get("bookingdeatils")
  const location = useLocation();
  const bookingData = location.state?.bookingData;
  const [resetImages, setResetImages] = useState(false);
  const servicetype = searchParams.get("type")
  const serviceIdFromQuery = searchParams.get("serviceId")
  const serviceNameFromQuery = searchParams.get("serviceName")

  // Fallback for refresh: get range from search params
  const rangeFromParams = useMemo(() => ({
    fromDate: searchParams.get("fromDate"),
    toDate: searchParams.get("toDate"),
    fromTime: searchParams.get("fromTime"),
    toTime: searchParams.get("toTime"),
    serviceId: searchParams.get("serviceId"),
    serviceName: searchParams.get("serviceName")
  }), [searchParams]);

  const [selectService, setSelectService] = useState<string>(searchParams.get("serviceId") || "");
  const [selectServiceName, setSelectServiceName] = useState<string>(searchParams.get("serviceName") || "");
  const { data: getservice, isFetching, isLoading } = useGetJobServiceQuery({})
  const { data: existingBookingsData, isFetching: isFetchingBookings } = useGetAcceptedGeneratedPostsAllQuery({});
  const userData = useAppSelector((state: any) => state.auth.user)

  // Add state for service-specific form data — lazy-init from URL params
  // so package-linked fields (cleaningType, subModality, supplies) are
  // pre-selected and locked from the very first render.
  const [serviceFormData, setServiceFormData] = useState<Record<string, any>>(() => {
    const initial: Record<string, any> = {};
    const subModality = searchParams.get('subModality');
    const cleaningType = searchParams.get('cleaningType');
    const supplies = searchParams.get('supplies');
    if (subModality) initial.subModality = subModality;
    if (cleaningType) initial.cleaningType = cleaningType;
    // Cleaning type is passed as ?subModality=... for cleaning services
    if (subModality && !cleaningType) initial.cleaningType = subModality;
    if (supplies) initial.supplies = supplies;
    return initial;
  });
  const [serviceFieldErrors, setServiceFieldErrors] = useState<Record<string, string>>({});

  // Add state for special needs modal
  const [showSpecialNeedsModal, setShowSpecialNeedsModal] = useState(false);
  const [pendingSpecialNeedsValue, setPendingSpecialNeedsValue] = useState<string | null>(null);
  const [notifySpecialNeeds, { isLoading: isNotifying }] = useNotifySpecialNeedsMutation();

  // Add state for terms and conditions
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsModalAccepted, setTermsModalAccepted] = useState(false);

  const getServiceNameById = (services: any[], id: string) => {
    const service = services.find(s => s._id === id);
    return service ? service.name : '';
  };

  // Function to get service type from service name
  const getServiceType = (serviceName: string): ServiceType | null => {
    if (!serviceName) return null;

    if (serviceTypeMapping[serviceName]) {
      return serviceTypeMapping[serviceName];
    }

    const serviceNameLower = serviceName.toLowerCase();
    for (const [key, value] of Object.entries(serviceTypeMapping)) {
      if (serviceNameLower.includes(key.toLowerCase())) {
        return value;
      }
    }

    return null;
  };

  // Function to handle service field changes
  const handleServiceFieldChange = (fieldName: string, value: any) => {
    // Check if this field is locked by a package selection
    const serviceType = getServiceType(selectServiceName);
    const fieldConfig = serviceType ? fieldsConfig[serviceType].find(f => f.name === fieldName) : null;
    const isFieldLocked = fieldConfig?.lockedBy &&
      serviceFormData[fieldConfig.lockedBy.sourceField] &&
      fieldConfig.lockedBy.valueMapping[serviceFormData[fieldConfig.lockedBy.sourceField]] !== undefined;

    // Special handling for specialNeeds field — skip modal if field is locked by package
    if (fieldName === 'specialNeeds' && value === 'Yes' && !isFieldLocked) {
      setPendingSpecialNeedsValue(value);
      setShowSpecialNeedsModal(true);
    } else {
      setServiceFormData(prev => ({
        ...prev,
        [fieldName]: value
      }));

      // Immediate validation
      const serviceType = getServiceType(selectServiceName);
      if (serviceType) {
        const newData = { ...serviceFormData, [fieldName]: value };
        const error = validateSingleField(serviceType, fieldName, newData);

        setServiceFieldErrors(prev => {
          const newErrors = { ...prev };
          if (error) {
            newErrors[fieldName] = error;
          } else {
            delete newErrors[fieldName];
          }

          // If kids changed, also re-validate ages to update dependency error
          if (fieldName === 'kids' && newData.ages) {
            const agesError = validateSingleField(serviceType, 'ages', newData);
            if (agesError) {
              newErrors['ages'] = agesError;
            } else {
              delete newErrors['ages'];
            }
          }

          return newErrors;
        });
      }
    }
  };

  // Handle modal confirmation
  const handleModalConfirmed = () => {
    if (pendingSpecialNeedsValue) {
      setServiceFormData(prev => ({
        ...prev,
        specialNeeds: pendingSpecialNeedsValue
      }));
      setPendingSpecialNeedsValue(null);
    }
    setShowSpecialNeedsModal(false);
  };

  // Handle modal cancellation
  const handleModalCanceled = () => {
    setPendingSpecialNeedsValue(null);
    setShowSpecialNeedsModal(false);
    // Reset the specialNeeds field to 'No'
    setServiceFormData(prev => ({
      ...prev,
      specialNeeds: 'No'
    }));
  };

  // Handle sending notification
  const handleSendNotification = async () => {
    try {
      const serviceType = getServiceType(selectServiceName) || 'nannies';
      const payload = {
        serviceType,
        ...serviceFormData,
        specialNeeds: 'Yes',
        timestamp: new Date().toISOString(),
      };

      await notifySpecialNeeds(payload).unwrap();
      handleModalConfirmed();
    } catch (error) {
      console.error('Failed to send special needs notification:', error);
      // Even if notification fails, continue with form
      handleModalConfirmed();
    }
  };

  // Handle terms acceptance
  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    setShowTermsModal(false);
  };

  // end post modla
  const handleServiceSelection = (value: any) => {
    setSelectService(value)

    if (getservice?.data) {
      const selectedService = getservice.data.find((s: any) => s._id === value);
      if (selectedService) {
        const serviceName = selectedService.name;
        setSelectServiceName(serviceName);

        // Check if it's a cleaning/housekeeping service
        // const isFixedProviderService = isCleaningOrHousekeepingService(serviceName); // Removed, handled by useEffect
        // setIsServiceProviderFixed(isFixedProviderService);

        // If it's cleaning/housekeeping, set count to 1 and reset duration to 2
        // if (isFixedProviderService) {
        //   setCount(1);
        //   setHoursSend(2); // Reset to minimum duration
        // }

        // Reset service form data when service changes
        setServiceFormData({});
        setServiceFieldErrors({});
      }
    }

    setErrorMsg((prevErrors) => ({
      ...prevErrors,
      selectServiceError: "",
    }));
  };

  const handleClickName = (name: any) => {
    setSelectServiceName(name)
  }

  const handleAdditionalInfo = (value: any) => {
    setTypeAdditionalInfo(value)
    setErrorMsg((prevErrors) => ({
      ...prevErrors,
      additionalInfo: "",
    }))
  }

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    if (getservice?.data) {
      // If we have serviceId from query params but couldn't find the service name
      if (serviceIdFromQuery && !selectServiceName) {
        const selectedService = getservice.data.find((s: any) => s._id === serviceIdFromQuery);
        if (selectedService) {
          setSelectServiceName(selectedService.name);
        }
      }
      // If we have serviceName from query params but couldn't find the service ID
      if (serviceNameFromQuery && !selectService) {
        const selectedService = getservice.data.find((s: any) => s.name === serviceNameFromQuery);
        if (selectedService) {
          setSelectService(selectedService._id);
        }
      }
    }
  }, [serviceIdFromQuery, serviceNameFromQuery, getservice?.data, selectService, selectServiceName])

  useEffect(() => {
    if (val) {
      setSelectService(val)
    }
  }, [val])

  // Centralized effect to handle fixed service state
  useEffect(() => {
    if (selectServiceName) {
      const isFixed = isCleaningOrHousekeepingService(selectServiceName);
      setIsServiceProviderFixed(isFixed);

      if (isFixed) {
        setCount(1);
        // We do NOT forcibly reset hoursSend here because it might conflict with 
        // the automatic duration calculation effect or existing edit data.
        // However, if it's a fresh selection (no existing duration logic active yet), 
        // the other effect will handle it.
        // Ensuring it's at least 2 is good practice though.
        setHoursSend(prev => Math.max(2, prev));
      }
    }
  }, [selectServiceName]);

  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([])
  const [open, setOpen] = useState(false)
  const handleLanguageChange = (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const selected = event.target.value as string[]
    if (selected.length > 2) {
      setOpen(false)
      setErrorMsg((prevError) => ({
        ...prevError,
        selectLanguage: "You can select maximum 2 languages",
      }))
      return
    }
    setOpen(false)
    setSelectedLanguages(selected)
    setErrorMsg((prevErrors) => ({
      ...prevErrors,
      selectLanguage: "",
    }))
  }

  const postDetails = useAppSelector(
    (state: any) => state.postCreate.bookingDetails,
  )

  const isEdit = !!(bookingData?._id || postDetails?._id || location.state?.from === 'calendar_edit');

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    sliderSetValue(newValue as number[])
  }

  // Add this function near your other helper functions
  const isCleaningOrHousekeepingService = (serviceName: string): boolean => {
    if (!serviceName) return false;

    const cleaningServiceNames = ['cleaning', 'housekeeping', 'cleaner', 'maid'];
    const serviceNameLower = serviceName.toLowerCase();

    return cleaningServiceNames.some(keyword =>
      serviceNameLower.includes(keyword)
    );
  };

  const schemaResolver = yup.object().shape({
    date: yup
      .string()
      .required("Date is required")
      .matches(/^(\d{4}-\d{2}-\d{2})( to \d{4}-\d{2}-\d{2})?$/, "Invalid date format (DD-MM-YYYY)"),
  })
  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<createBooking, any>({
    resolver: yupResolver(schemaResolver),
  })

  const validateServiceFields = (): boolean => {
    const serviceType = getServiceType(selectServiceName);
    if (!serviceType) return true;

    const validationResult = validateServiceFieldsExternal(serviceType, serviceFormData);

    setServiceFieldErrors(validationResult.errors);
    return validationResult.isValid;
  };

  const onSubmit = async () => {
    if ((!selectedDate && !dateRange) || !selectedStartTime) {
      console.error("Missing date or start time");
      return;
    }

    try {
      // Create date in local timezone
      const dateToUse = dateRange ? dateRange.fromDate : selectedDate;
      const localDateTime = createLocalDateTime(dateToUse, selectedStartTime);

      // Validate the date object
      if (isNaN(localDateTime.getTime())) {
        console.error("Invalid date/time combination");
        return;
      }

      // Convert to ISO string (Preserving Local Time with Offset)
      const utcString = formatToLocalWithOffset(localDateTime);

      // Fix for fractional hours: use timestamp calculation instead of setHours
      const endDateTime = new Date(localDateTime.getTime() + hoursSend * 60 * 60 * 1000);
      const endUtcString = formatToLocalWithOffset(endDateTime);

      const payload: Payload = {
        location: loactionSearchData,
        service: selectService,
        serviceName: selectServiceName,
        ageRange: slidervalue.toString(),
        from: utcString,  // Sent as ISO string but reflecting local time
        till: endUtcString,  // Sent as ISO string but reflecting local time
        description: typeadditionalInfo || "",
        personRequired: count.toString(),
        language: selectedLanguages,
        attachment: arrayImages as any,
        hours: hoursSend,
        postPrice: priceData,
        tax: taxData,
        stripepricekey: selectBookOffers?.map(
          (item: any) => item?.stripePriceKey,
        ),
        timeUpdate: selectedStartTime,
        updateEndTime: endTimeShow,

        extraDetails: serviceFormData,
        _id: bookingData?._id || postDetails?._id, // Pass _id for update tracking
        dateRange: dateRange // Pass date range for multiple booking creation
      }

      dispatch(setBookingDetails(payload as any));
      setBookingDetailsShow(true);
      navigate(`/dashboard/edit-bookings`);
    } catch (error) {
      console.error("Error in onSubmit:", error);
    }
  };

  const onValidation = () => {
    const newErrors: ErrorProps = {
      startOnTimer: "",
      selectLocation: "",
      selectLanguage: "",
      selectServiceError: "",
      additionalInfo: "",
      // photos: "" 
    }

    let isValid = true;

    if (hoursSend < 2) {
      newErrors.startOnTimer = "Minimum booking duration is 2 hours.";
      isValid = false;
    } else {
      // Check for conflicts
      const bookingId = bookingData?._id || postDetails?._id;

      // Get local bookings from session storage
      const saved = sessionStorage.getItem('booking_calendar_items');
      const localBookings = saved ? JSON.parse(saved) : [];

      // Merge backend and local bookings for comprehensive validation
      const allBookings = [
        ...(existingBookingsData?.data || []),
        ...localBookings
      ];

      if (dateRange) {
        const [fYear, fMonth, fDay] = dateRange.fromDate.split('-').map(Number);
        const [tYear, tMonth, tDay] = dateRange.toDate.split('-').map(Number);
        const start = new Date(fYear, fMonth - 1, fDay);
        const end = new Date(tYear, tMonth - 1, tDay);
        let loop = new Date(start);
        while (loop <= end) {
          const dateStr = getLocalDateString(loop);
          const slotIso = formatToLocalWithOffset(createLocalDateTime(dateStr, selectedStartTime));
          const hasConflict = checkBookingConflict(
            { _id: bookingId, serviceId: selectService, from: slotIso },
            allBookings
          );
          if (hasConflict) {
            newErrors.startOnTimer = `Slot already booked`;
            isValid = false;
            break;
          }
          loop.setDate(loop.getDate() + 1);
        }
      } else if (selectedDate && selectedStartTime) {
        const isoFrom = formatToLocalWithOffset(createLocalDateTime(selectedDate, selectedStartTime));
        const hasConflict = checkBookingConflict(
          { _id: bookingId, serviceId: selectService, from: isoFrom },
          allBookings
        );
        if (hasConflict) {
          newErrors.startOnTimer = "Slot already booked.";
          isValid = false;
        }
      }
    }

    // Service selection validation
    if (selectService === "") {
      newErrors.selectServiceError = "Please select a service."
      isValid = false;
    }

    // Service detail validation
    const serviceType = getServiceType(selectServiceName);
    if (serviceType) {
      const validationResult = validateServiceFieldsExternal(serviceType, serviceFormData);
      if (!validationResult.isValid) {
        setServiceFieldErrors(validationResult.errors);
        isValid = false;
      } else {
        setServiceFieldErrors({});
      }
    }

    // Additional validation for service details
    if (selectServiceName && serviceType) {
      const requiredFields = fieldsConfig[serviceType].filter(field => field.required);
      for (const field of requiredFields) {
        // Check if field should be shown based on conditionals
        let shouldShow = true;
        if (field.conditional) {
          const { field: conditionalField, value: expectedValue } = field.conditional;
          const conditionalValue = serviceFormData[conditionalField];

          if (Array.isArray(conditionalValue)) {
            shouldShow = conditionalValue.includes(expectedValue);
          } else {
            shouldShow = conditionalValue === expectedValue;
          }
        }

        if (shouldShow && (!serviceFormData[field.name] || serviceFormData[field.name].toString().trim() === "")) {
          setServiceFieldErrors(prev => ({
            ...prev,
            [field.name]: `${field.label} is required`
          }));
          isValid = false;
        }
      }
    }

    //additional Info
    if (!typeadditionalInfo || typeadditionalInfo.trim() === "") {
      newErrors.additionalInfo = "Additional instructions are required.";
      isValid = false;
    } else {
      const countWords = (text: any) => text.trim().split(/\s+/).length;
      const hasConsecutiveSpaces = (text: string) => /\s{2,}/.test(text)

      if (countWords(typeadditionalInfo) > 50) {
        newErrors.additionalInfo = "Additional information cannot exceed 50 words.";
        isValid = false;
      } else if (hasConsecutiveSpaces(typeadditionalInfo)) {
        newErrors.additionalInfo = "Additional information should not contain consecutive spaces.";
        isValid = false;
      }
    }

    // Check Location
    if (!loactionSearchData || loactionSearchData.trim() === "") {
      newErrors.selectLocation = "Please select your location."
      isValid = false;
    } else if (/\s{2,}/.test(loactionSearchData)) {
      newErrors.selectLocation = "Location must not contain consecutive spaces."
      isValid = false;
    }

    // Check Language
    if (selectedLanguages.length === 0) {
      newErrors.selectLanguage = "Please select at least 1 language.";
      isValid = false;
    } else if (selectedLanguages.length > 2) {
      newErrors.selectLanguage = "You can select maximum 2 languages";
      isValid = false;
    }

    // Check Terms and Conditions
    if (!termsAccepted) {
      // Show terms modal if not accepted instead of showing error
      setShowTermsModal(true);
      return; // Stop submission
    }

    // Photos validation
    // if (arrayImages.length === 0) {
    //   newErrors.photos = "Please add at least one photo.";
    //   isValid = false;
    // }

    setErrorMsg(newErrors);

    if (isValid) {
      onSubmit()
    }
  }

  const handleIncrement = (key: any) => {
    if (key === "hours") {
      // Remove the 23:00 check and 24-hour limit
      if (hoursSend < 24) { // Allow up to 24 hours
        setHoursSend(hoursSend + 1)
      }
    } else if (key === "count" && count < 7) {
      setCount(count + 1)
    }
  }

  const handleDecriment = (key: any) => {
    if (key == "count" && count > 1) {
      setCount(count - 1)
    } else if (key == "hours") { // Keep minimum 2 hours
      setHoursSend(Math.max(2, hoursSend - 1))
    }
  }

  // confirm Modal on Submit

  const selectBookOffers = getservice?.data?.filter(
    (offers: any) => offers?._id == selectService,
  )

  const selectBookTax = getservice?.data?.filter(
    (taxSer: any) => taxSer?._id == selectService,
  )

  // For edits or duplicates, use the provided data
  const dataToUse = bookingData || postDetails;

  useEffect(() => {
    reset({
      date: selectedDate,
    })
  }, [reset, selectedDate])
  // end function price with service

  // Clear or update Redux store based on navigation context
  // This must run BEFORE the main data population useEffect
  useEffect(() => {
    const isNewBookingFromCalendar =
      location.state?.from === 'calendar_new' ||
      location.state?.from === 'calendar_initial_setup' ||
      (rangeFromParams.fromDate && rangeFromParams.fromTime);
    const isEditFromCalendar = location.state?.from === 'calendar_edit';

    if (isEdit && dataToUse?.personRequired) {
      const personRequiredNumber = parseInt(dataToUse.personRequired, 10)
      if (!isNaN(personRequiredNumber)) {
        setCount(personRequiredNumber)
      }
    } else if (isCleaningOrHousekeepingService(selectServiceName)) {
      // For cleaning/housekeeping services, always set count to 1
      setCount(1);
      setIsServiceProviderFixed(true);
    } else {
      setCount(1);
      setIsServiceProviderFixed(false);
    }

    if (isNewBookingFromCalendar) {
      // Clear the Redux store to prevent old data from showing
      dispatch(setBookingDetails(null as any));
    } else if (isEditFromCalendar && bookingData) {
      // Update Redux store with the current booking data for edits
      // This ensures the form shows the correct booking's data
      dispatch(setBookingDetails(bookingData as any));
    }
  }, [location.state?.from, bookingData, dispatch]);

  useEffect(() => {
    // Check if this is a new booking from calendar
    const isNewBookingFromCalendar =
      (location.state?.from === 'calendar_new' ||
        location.state?.from === 'calendar_initial_setup' ||
        (rangeFromParams.fromDate && rangeFromParams.fromTime)) && !isEdit;

    // For new bookings from calendar, don't pre-populate with old data
    if (isNewBookingFromCalendar) {
      // Explicitly set service fields from URL params (not from old data)
      if (serviceIdFromQuery) {
        setSelectService(serviceIdFromQuery);
      }
      if (serviceNameFromQuery) {
        setSelectServiceName(serviceNameFromQuery);
      }

      // Reset all other fields to defaults
      setTypeAdditionalInfo('');
      setLocationSearchData('');
      setSelectedLanguages([]);
      setCount(1);
      sliderSetValue([18, 45]);

      const range = location.state?.range || location.state?.dateRange || rangeFromParams;
      if (range && range.fromTime && range.toTime) {
        const startParts = range.fromTime.split(':').map(Number);
        const endParts = range.toTime.split(':').map(Number);

        const startMinutes = startParts[0] * 60 + (startParts[1] || 0);
        const endMinutes = endParts[0] * 60 + (endParts[1] || 0);

        let diffMinutes = endMinutes - startMinutes;
        if (diffMinutes < 0) diffMinutes += 24 * 60;

        let h = diffMinutes / 60;

        if (h < 2) h = 2;
        setHoursSend(h);
      } else {
        setHoursSend(2);
      }

      // Build serviceFormData atomically — single setState, no clear-then-rebuild
      const formData: Record<string, any> = {};
      const subModalityFromQuery = searchParams.get('subModality');
      const cleaningTypeFromQuery = searchParams.get('cleaningType');
      const suppliesFromQuery = searchParams.get('supplies');
      if (subModalityFromQuery) formData.subModality = subModalityFromQuery;
      if (cleaningTypeFromQuery) formData.cleaningType = cleaningTypeFromQuery;
      // Cleaning type comes as ?subModality=... for cleaning services
      if (subModalityFromQuery && !cleaningTypeFromQuery) formData.cleaningType = subModalityFromQuery;
      if (suppliesFromQuery) formData.supplies = suppliesFromQuery;
      setServiceFormData(formData);

         setServiceFieldErrors({}); // Clear any validation errors
         setTermsAccepted(false);
      setArrayImages([]);
      setResetImages(true);
      return;
    }

    // Only populate if we have valid data
    if (!dataToUse) return;

    setTypeAdditionalInfo(dataToUse?.description)
    setSelectService(dataToUse?.service || "")
    if (dataToUse?.service && getservice?.data) {
      setSelectServiceName(getServiceNameById(getservice.data, dataToUse.service));
    }
    setLocationSearchData(dataToUse?.location)
    setSelectedLanguages(dataToUse?.language || [])

    if (dataToUse?.hours) {
      const personHours = parseFloat(dataToUse.hours) // Use parseFloat to keep decimal/half hours
      if (!isNaN(personHours)) {
        // Ensure minimum of 2 hours
        setHoursSend(Math.max(personHours, 2))
      }
    } else {
      // Default to 2 hours if not provided
      setHoursSend(2)
    }

    if (dataToUse?.personRequired) {
      const personRequiredNumber = parseInt(dataToUse.personRequired, 10)
      if (!isNaN(personRequiredNumber)) {
        setCount(personRequiredNumber)
      }
    }

    if (dataToUse?.ageRange) {
      if (dataToUse?.ageRange) {
        const ages = dataToUse.ageRange.split(",").map(Number)
        if (ages.length === 2 && ages[0] >= 18 && ages[1] <= 45) {
          sliderSetValue(ages)
        }
      }
    }

    if (dataToUse?.extraDetails) {
      setServiceFormData(dataToUse.extraDetails);
    } else {
      // Clear service form data if no extra details
      setServiceFormData({});
    }

    // Pre-fill terms acceptance if editing
    if (dataToUse?.termsAccepted) {
      setTermsAccepted(dataToUse.termsAccepted);
    }
  }, [postDetails, bookingData, location.state?.from, serviceIdFromQuery, serviceNameFromQuery, getservice?.data])

  // Pre-fill location & language from Redux auth.user (already loaded from login)
  useEffect(() => {
    if (!userData || isEdit) return;

    if (userData.address?.location && !loactionSearchData) {
      setLocationSearchData(userData.address.location);
    }
    if (userData.language?.length > 0 && selectedLanguages.length === 0) {
      setSelectedLanguages(userData.language);
    }
  }, [userData, isEdit, loactionSearchData, selectedLanguages])

  useEffect(() => {
    let initialDate;
    const dateFromQuery = searchParams.get("date");
    const dateFromState = bookingData?.date;

    const range = location.state?.range || location.state?.dateRange || (rangeFromParams.fromDate ? rangeFromParams : null);

    const absoluteFrom = bookingData?.from || postDetails?.from;

    if (absoluteFrom && !location.state?.range) {
      // Prioritize capturing the local date part from the absolute timestamp
      initialDate = getLocalDateString(new Date(absoluteFrom));
    } else if (dateFromState) {
      initialDate = dateFromState;
    } else if (range && range.fromDate) {
      // Prioritize range from calendar selection
      if (range.fromDate !== range.toDate && range.toDate) {
        initialDate = `${range.fromDate} to ${range.toDate}`;
      } else {
        initialDate = range.fromDate;
      }
    } else if (dateFromQuery) {
      initialDate = dateFromQuery;
    } else {
      // Use current LOCAL date
      initialDate = getLocalDateString(new Date());
    }

    setSelectedDate(initialDate);

    // Ensure we use the start date for calculating time availability
    const dateForTimes = (initialDate && initialDate.includes(' to '))
      ? initialDate.split(' to ')[0]
      : initialDate;

    updateAvailableTimes(dateForTimes, true);
  }, [postDetails?.from, bookingData, searchParams]);

  const handleDateChange = (e: any) => {
    const newDate = e.target.value

    setSelectedDate(newDate)
    updateAvailableTimes(newDate, true)
  }

  const handleStartTimeChange = (e: any) => {
    const newStartTime = e.target.value;
    setSelectedStartTime(newStartTime);

    setErrorMsg((prevErrors) => ({
      ...prevErrors,
      startOnTimer: "",
    }));

    updateEndTimeOptions(newStartTime);
  }

  const updateAvailableTimes = (date: any, isInitialSetup = false) => {
    const times = generateTimes(date)
    setStartTimeOptions(times as any)
    if (times.length > 0) {
      const initialTime = times[0]

      // Prioritize startTime from state/props if this is initial setup
      // Check for absolute timestamp first (absolute truth), then static strings
      const range = location.state?.range || location.state?.dateRange || (rangeFromParams.fromTime ? rangeFromParams : null);
      const absoluteFrom = bookingData?.from || postDetails?.from;
      let stateStartTime = "";

      if (absoluteFrom && !location.state?.range) {
        stateStartTime = getLocalTimeString(new Date(absoluteFrom));
      } else {
        stateStartTime = bookingData?.timeUpdate || bookingData?.startTime || postDetails?.timeUpdate || range?.fromTime;
      }

      let timeToSet = (isInitialSetup && stateStartTime) ? stateStartTime : (stateStartTime || initialTime);

      // Validate that timeToSet exists in the available times
      if (!times.includes(timeToSet)) {
        timeToSet = initialTime;
      }

      setSelectedStartTime(timeToSet)

      if (isInitialSetup) {
        updateEndTimeOptions(timeToSet, times)
      } else {
        // If current selected time is no longer valid (e.g. date change changed availability)
        // verify and update if needed.
        // Since we just set it based on validation above, we might just need to update end time options.
        // However, updateEndTimeOptions uses startTimeOptions state which we just set... 
        // But setStartTimeOptions is async/batch? No, it's useState setter.
        // We passed `times` to updateEndTimeOptions, so it's fine.
        updateEndTimeOptions(timeToSet, times)
      }
    }
  }

  const updateEndTimeOptions = (
    startTime: string,
    times: string[] = startTimeOptions as string[] // Default to startTimeOptions
  ) => {
    const startTimeIndex = times.indexOf(startTime);
    const newEndTimeOptions = times.slice(startTimeIndex + 1);
    setEndTimeOptions(newEndTimeOptions as never[]);
    if (newEndTimeOptions.length > 0) {
      setSelectedEndTime(newEndTimeOptions[0]);
    } else {
      setSelectedEndTime("");
    }
  };

  const generateTimes = (date: string) => {
    const times = [];
    const safeLimit = dayjs().add(2, 'hour');

    // Generate all 15-minute slots for the day, filtering by safe limit
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const timeStr = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        // Construct exact datetime for this slot
        const slotDateTime = dayjs(`${date} ${timeStr}`);

        // Included if it's after or same as the safe limit
        if (slotDateTime.isAfter(safeLimit) || slotDateTime.isSame(safeLimit, 'minute')) {
          times.push(timeStr);
        }
      }
    }

    return times;
  };

  useEffect(() => {
    if (!selectedStartTime) return;

    const [hoursStr, minutesStr] = selectedStartTime.split(":");
    const startHours = parseInt(hoursStr, 10);
    const startMinutes = parseInt(minutesStr, 10);

    const totalMinutes = startHours * 60 + startMinutes + hoursSend * 60;

    // Calculate new time
    const newHours = Math.floor(totalMinutes / 60) % 24;
    const newMinutes = Math.floor(totalMinutes % 60);

    const newTimeString = `${newHours.toString().padStart(2, "0")}:${newMinutes.toString().padStart(2, "0")}`;

    // Calculate days passed to check for next day
    const daysPassed = Math.floor(totalMinutes / (24 * 60));

    if (daysPassed > 0) {
      setIsNextDay(true);
      setEndTimeShow(newTimeString);
    } else {
      setIsNextDay(false);
      setEndTimeShow(newTimeString);
    }
  }, [selectedStartTime, hoursSend, selectedDate]);

  const dateRange = location.state?.range || location.state?.dateRange || (rangeFromParams.fromDate && rangeFromParams.toDate ? rangeFromParams : null);

  useEffect(() => {
    if (dateRange) {
      const rangeString = (dateRange.fromDate === dateRange.toDate || !dateRange.toDate)
        ? dateRange.fromDate
        : `${dateRange.fromDate} to ${dateRange.toDate}`;
      setSelectedDate(rangeString);
      setValue('date', rangeString); // Manually set form validation value
      if (dateRange.fromTime) {
        setSelectedStartTime(dateRange.fromTime);
        // Trigger time update logic?
        // calculate hours from fromTime and toTime
        const startParts = dateRange.fromTime.split(':').map(Number);
        const endParts = dateRange.toTime.split(':').map(Number);
        const startMinutes = startParts[0] * 60 + (startParts[1] || 0);
        const endMinutes = endParts[0] * 60 + (endParts[1] || 0);
        let h = (endMinutes - startMinutes) / 60;
        if (h < 0) h += 24;
        if (h < 2) h = 2; // minimum
        setHoursSend(h);
        setEndTimeShow(dateRange.toTime);

        const times = generateTimes(dateRange.fromDate)
        setStartTimeOptions(times as any)
        setSelectedStartTime(dateRange.fromTime);
        // Set end time from URL, falling back to calculated end
        if (dateRange.toTime && times.includes(dateRange.toTime)) {
          setSelectedEndTime(dateRange.toTime);
          // Also set end time options so the dropdown shows the correct selection
          const startTimeIndex = times.indexOf(dateRange.fromTime);
          const endTimeIndex = times.indexOf(dateRange.toTime);
          if (startTimeIndex >= 0 && endTimeIndex > startTimeIndex) {
            setEndTimeOptions(times.slice(startTimeIndex + 1) as never[]);
          }
        } else {
          updateEndTimeOptions(dateRange.fromTime, times);
        }
      }
    }
  }, [dateRange]);


  // for price
  useEffect(() => {
    const bookingPrice = selectBookOffers?.map((ammount: any) => ammount?.price)
    const stringPrice = bookingPrice?.join()

    setPriceData(stringPrice)
  }, [selectBookOffers])

  useEffect(() => {
    const bookingTax = selectBookTax?.map((amount: any) => amount?.tax)
    const stringTax = bookingTax?.join()

    setTaxData(stringTax)
  }, [selectBookTax])

  // Automatic duration calculation for Housekeeping and Cleaning services
  useEffect(() => {
    if (!selectServiceName) return;

    const isCleaningOrHousekeeping = ['cleaning', 'housekeeping', 'cleaner', 'maid'].some(keyword =>
      selectServiceName.toLowerCase().includes(keyword)
    );

    if (isCleaningOrHousekeeping) {
      // Base configuration: Total 5 (rooms + washrooms) = 2 hours
      const baseTotal = 5;
      const baseDuration = 2;

      const currentRooms = Number(serviceFormData.rooms) || 0;
      const currentWashrooms = Number(serviceFormData.washrooms) || 0;

      const distinctTotal = currentRooms + currentWashrooms;

      let additionalHours = 0;

      // Increase half an hour for each unit above base total
      if (distinctTotal > baseTotal) {
        additionalHours = (distinctTotal - baseTotal) * 0.5;
      }

      const newDuration = Math.max(2, baseDuration + additionalHours);

      // Avoid infinite loops by only updating if changed
      setHoursSend(prev => {
        if (prev !== newDuration) return newDuration;
        return prev;
      });
    }
  }, [serviceFormData, selectServiceName]);

  // For Image Multiples
  // function base64ToFile(base64Data: any, filename: any, mimeType: any) {
  //   const byteCharacters = atob(base64Data.split(",")[1])
  //   const byteArrays = []

  //   for (let offset = 0; offset < byteCharacters.length; offset += 512) {
  //     const slice = byteCharacters.slice(offset, offset + 512)

  //     const byteNumbers = new Array(slice.length)
  //     for (let i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i)
  //     }

  //     const byteArray = new Uint8Array(byteNumbers)
  //     byteArrays.push(byteArray)
  //   }

  //   const file = new File(byteArrays, filename, { type: mimeType })
  //   return file
  // }

  // const imagesArray = (key: any) => {
  //   setArrayImages(key)
  //   if (key.length > 0 && errorMsg.photos) {
  //   setErrorMsg(prev => ({
  //     ...prev,
  //     photos: ""
  //   }));
  // }
  // }

  // reapeat post data


  const handleDelete = (languageToDelete: string) => {
    setSelectedLanguages((prevLanguage) =>
      prevLanguage.filter((lang) => lang !== languageToDelete),
    )
    setErrorMsg((prev) => ({
      ...prev,
      selectLanguage: "",
    }))
  }

  // Salon bookings are temporarily frozen. Backstop for direct/deep links to
  // create-booking?serviceName=Salon%20Service — block the form entirely.
  const isSalonFrozen = getServiceType(selectServiceName) === "salon"

  return (
    <>
      {isFetching || isLoading || isFetchingBookings ? (
        <CenteredSpinner />
      ) : isSalonFrozen ? (
        <Box className="">
          <Style.Overview>
            <Box className="feature-card pt-md-4 px-md-4">
              <Button
                onClick={() => navigate(`/dashboard/features`)}
                className="back-btn"
              >
                <FaChevronLeft />
              </Button>
              <Box
                sx={{
                  textAlign: "center",
                  py: 8,
                  px: 2,
                  maxWidth: 480,
                  mx: "auto",
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  Salon bookings are coming soon
                </Typography>
                <Typography variant="body1" sx={{ color: "#666", mb: 3 }}>
                  Salon services will be available soon. Please check back, or
                  explore our other services in the meantime.
                </Typography>
                <Button
                  onClick={() => navigate(`/dashboard/features`)}
                  sx={{
                    backgroundColor: "#f475A4",
                    color: "#fff",
                    textTransform: "capitalize",
                    px: 3,
                    py: 1,
                    "&:hover": { backgroundColor: "#e05e90" },
                  }}
                >
                  Browse Services
                </Button>
              </Box>
            </Box>
          </Style.Overview>
        </Box>
      ) : (
        <Box className="">
          <Style.Overview>
            <Box className="feature-card pt-md-4 px-md-4">
              {bookingDetailsShow && (
                <span
                  className="step-back-btn"
                  onClick={() => {
                    setBookingDetailsShow(false)
                    setSearchParams({})
                  }}
                >
                  <FaChevronLeft />
                </span>
              )}
              {bookingDetailsShow && (
                <Stepper className="stepper-booking mb-5 pt-3">
                  {steps.map((label, index) => (
                    <Step key={label}>
                      <StepLabel style={{ fontWeight: 700 }}>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              )}

              <form onSubmit={handleSubmit(onValidation)}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    lg={5}
                    className="mb-2 mb-md-4 h-auto pe-md-2"
                  >
                    <Box className="feature-card shadow-none p-2 mb-2 mb-md-4 d-flex align-items-center gap-4">
                      <Grid container>
                        <Grid item xs={12}>
                          <Typography className="field-label mb-2">
                            <span style={{ color: "red" }}>*</span> Service
                            Required
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          {/* <FormControl sx={{ m: 1, mx: 0 }} fullWidth> */}
                          {/* <InputLabel id="service-label"
                              className="bg-white"
                              sx={{
                                "&.Mui-focused": {
                                  color: "#f07fa9",
                                },
                              }}
                            >
                              Select A Service
                            </InputLabel>

                            <Select
                              labelId="service-label"
                              id="serviceId"
                              disabled={true}
                              fullWidth
                              value={selectService || ""}
                              onChange={(event) =>
                                handleServiceSelection(event.target.value)
                              }
                              sx={{
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderRadius: "12px",
                                },
                                // "&:hover .MuiOutlinedInput-notchedOutline": {
                                //   borderColor: "#f07fa9",
                                // },
                                // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                //   borderColor: "#f07fa9",
                                // },
                              }}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 250,
                                    width: 300, // Increased for better readability
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                    scrollbarColor: "#f07fa9 transparent",
                                    borderRadius: "12px",
                                    cursor: "pointer",
                                  },
                                },
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "left",
                                },
                              }}
                            >
                              {getservice?.data?.map(
                                (option: any, index: number) => (
                                  <MenuItem
                                    key={index}
                                    value={option?._id}
                                    onClick={() => handleClickName(option.name)}
                                    sx={{
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {option.name}
                                  </MenuItem>
                                ),
                              )}
                            </Select>

                            */}
                          {/* Optional Error Message */}
                          {/* <p className="text-danger error-text">
                              {errorMsg?.selectServiceError}
                            </p>  */}

                          {/* ✅ Service Detail Text shown below in full width */}
                          {selectServiceName && (
                            <Box
                              mt={2}
                              p={2}
                              sx={{
                                backgroundColor: "#f9f9f9",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                color: "#333",
                                fontSize: "14px",
                                whiteSpace: "pre-wrap", // Keeps line breaks and formatting
                                wordBreak: "break-word", // Breaks long words
                              }}
                            >
                              <strong>Selected Service:</strong>{" "}
                              {selectServiceName}
                            </Box>
                          )}
                          {/* </FormControl> */}
                        </Grid>
                      </Grid>
                    </Box>

                    {/* Live Price Estimate */}
                    {selectServiceName && (() => {
                      const serviceObj = getservice?.data?.find((s: any) => s._id === selectService);
                      const pricingConfig = serviceObj?.pricingConfiguration;
                      const hasDynamicPricing = pricingConfig && (
                        pricingConfig.subModality ||
                        (pricingConfig.yes && typeof pricingConfig.yes === 'object') ||
                        (typeof pricingConfig.yes === 'number')
                      );
                      // Use LivePriceCalculator for services with pricing configuration
                      if (hasDynamicPricing) {
                        const subMod = serviceFormData.subModality || serviceFormData.cleaningType || '';
                        const sup = serviceFormData.supplies || 'No';
                        return (
                          <LivePriceCalculator
                            subModality={subMod}
                            supplies={sup}
                            hours={hoursSend}
                            persons={count}
                            pricingConfiguration={pricingConfig}
                            includedServices={
                              serviceFormData.subModality && pricingConfig?.subModality?.[serviceFormData.subModality]?.includedServices
                                ? pricingConfig.subModality[serviceFormData.subModality].includedServices
                                : undefined
                            }
                          />
                        );
                      }
                      // Generic estimate for services without pricing config
                      if (!serviceObj || !serviceObj.price) return null;
                      const hourlyRate = serviceObj.price;
                      const taxPct = serviceObj.tax || 12;
                      const billableHrs = hoursSend * count;
                      const subtotal = billableHrs * hourlyRate;
                      const taxAmt = (subtotal * taxPct) / 100;
                      const total = subtotal + taxAmt;
                      return (
                        <Box className="feature-card shadow-none p-2 mb-2 mb-md-4" sx={{ bgcolor: "#fafafa", border: "1px solid #e0e0e0" }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#333" }}>Price Estimate</Typography>
                          <Box sx={{ fontSize: "0.85rem", color: "#555" }}>
                            <Box display="flex" justifyContent="space-between" mb={0.5}>
                              <span>Package Rate</span>
                              <span><strong>C$ {hourlyRate}/hr</strong></span>
                            </Box>
                            <Box display="flex" justifyContent="space-between" mb={0.5}>
                              <span>Duration ({hoursSend}h × {count} {count > 1 ? 'persons' : 'person'})</span>
                              <span><strong>{billableHrs.toFixed(1)} hrs</strong></span>
                            </Box>
                            <hr style={{ margin: "6px 0", border: "none", borderTop: "1px solid #ddd" }} />
                            <Box display="flex" justifyContent="space-between" mb={0.5}>
                              <span>Subtotal</span>
                              <span><strong>C$ {subtotal.toFixed(2)}</strong></span>
                            </Box>
                            <Box display="flex" justifyContent="space-between" mb={0.5}>
                              <span>Tax ({taxPct}%)</span>
                              <span><strong>C$ {taxAmt.toFixed(2)}</strong></span>
                            </Box>
                            <hr style={{ margin: "6px 0", border: "none", borderTop: "1px solid #ddd" }} />
                            <Box display="flex" justifyContent="space-between">
                              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#222" }}>Total</Typography>
                              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#f475a4" }}>${total.toFixed(2)}</Typography>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })()}

                    <Box className="d-flex align-items-center gap-4 p-2 mt-md-5 mb-5">
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item xs={12} sm={4} >
                          <Typography className="field-label pb-md-0 pb-2">
                            <span style={{ color: "red" }}>*</span> Select Date
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8} alignItems="center">
                          <Box className="d-flex flex-wrap gap-2">
                            <Box className="mb-2 w-100 d-flex">
                              {(bookingDetailsShow || !!dateRange || isEdit) ? (
                                <input
                                  disabled
                                  type="text"
                                  id="dateSelect"
                                  className="w-100 date-field no-icon"
                                  value={
                                    selectedDate?.includes(" to ")
                                      ? selectedDate.split(" to ").map(d => d.split("-").reverse().join("-")).join(" to ")
                                      : selectedDate?.split("-").reverse().join("-")
                                  }
                                />
                              ) : (
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <MobileDatePicker
                                    value={selectedDate ? dayjs(selectedDate) : null}
                                    onChange={(newValue) => {
                                      if (newValue) {
                                        const formatted = newValue.format('YYYY-MM-DD');
                                        setSelectedDate(formatted);
                                        updateAvailableTimes(formatted, true);
                                        setValue("date", formatted);
                                      }
                                    }}
                                    format="DD-MM-YYYY"
                                    minDate={dayjs(getLocalDateString(new Date()))}
                                    slotProps={{
                                      textField: {
                                        fullWidth: true,
                                        size: "small",
                                        autoComplete: 'off',
                                        className: "w-100 date-field-mui no-icon",
                                        sx: {
                                          '& .MuiOutlinedInput-root': {
                                            borderRadius: "11px",
                                            height: "57px",
                                            '& fieldset': { border: "none" },
                                            // Ensure we hide any default MUI adornments if they exist
                                            '& .MuiInputAdornment-root': {
                                              display: 'none',
                                            }
                                          },
                                          '& .MuiInputBase-input': {
                                            padding: "17px 0 17px 17px",
                                            fontSize: "16px",
                                            fontWeight: "500",
                                          }
                                        }
                                      }
                                    }}
                                  />
                                </LocalizationProvider>
                              )}
                              <p className="text-danger error-text">
                                {errors?.date?.message}
                              </p>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    {!bookingDetailsShow && (
                      <Box className="d-flex align-items-center gap-1 gap-md-4 p-2 mb-5">
                        <Grid container>
                          <Grid item xs={12} sm={4} className="m-auto">
                            <Typography className="field-label pb-sm-0 pb-2">
                              <span style={{ color: "red" }}>*</span> Select Time
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={8}>
                            <Box className="d-flex gap-4">
                              <Box className="d-flex flex-column justify-content-center align-items-center gap-2">
                                <Box>
                                  {" "}
                                  <Typography className="field-label font-14">
                                    Start Time
                                  </Typography>
                                </Box>
                                <Box
                                  className="time-picker-field"
                                  style={{ height: "57px" }}
                                >
                                  <DemoItem>
                                    <select
                                      disabled={bookingDetailsShow}
                                      id="startTimeSelect"
                                      className="date-field"
                                      value={selectedStartTime}
                                      onChange={handleStartTimeChange}
                                    // {...register("from")} // Register "from" field
                                    >
                                      {startTimeOptions.map((time, index) => (
                                        <option key={index} value={time}>
                                          {time}
                                        </option>
                                      ))}
                                    </select>
                                  </DemoItem>
                                  <p className="text-danger error-text">
                                    {errorMsg?.startOnTimer}
                                  </p>
                                </Box>
                              </Box>

                              <Box className="d-flex flex-column gap-2 justify-content-center align-items-center">
                                <Box>
                                  {" "}
                                  <Typography className="field-label font-14">
                                    Hours{" "}
                                  </Typography>
                                </Box>
                                <Box className="d-flex align-items-center gap-2 gap-md-3">
                                  <Button
                                    className="control-btn p-0 bg-transparent minus-btn"
                                    onClick={() => handleDecriment("hours")}
                                    disabled={isLoading || bookingDetailsShow || isServiceProviderFixed} // Disable for fixed services like cleaning
                                  >
                                    <img
                                      src={
                                        hoursSend <= 2 ? minusImg : PinkMinusImg
                                      }
                                      className=""
                                      style={{ opacity: (isLoading || bookingDetailsShow || isServiceProviderFixed) ? 0.5 : 1 }}
                                    />
                                  </Button>
                                  <Input
                                    disabled={isLoading || bookingDetailsShow || isServiceProviderFixed} // Disable for fixed services
                                    type="text"
                                    inputMode="numeric"
                                    placeholder="Give title to service"
                                    className="feature-field font-16 service-provider-field count-field d-flex  select-time-field"
                                    value={hoursSend}
                                    sx={{
                                      backgroundColor: isServiceProviderFixed ? "#f5f5f5" : "transparent",
                                      cursor: isServiceProviderFixed ? "not-allowed" : "text",
                                      textAlign: 'center'
                                    }}
                                  />
                                  <Button
                                    className="control-btn p-0 bg-transparent plus-btn"
                                    onClick={() => handleIncrement("hours")}
                                    disabled={isLoading || bookingDetailsShow || isServiceProviderFixed} // Disable for fixed services
                                  >
                                    <img
                                      src={plusImg}
                                      style={{ opacity: (isLoading || bookingDetailsShow || isServiceProviderFixed) ? 0.5 : 1 }}
                                    />
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    <Box className="d-flex align-items-center gap-4 p-2 mt-md-5 mb-5">
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item xs={12} sm={4}>
                          <Typography className="field-label pb-sm-0 pb-2">
                            Total Time
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                          <div
                            className="d-flex flex-column justify-content-center align-items-center text-center"
                            style={{
                              background: "#f6f6f6",
                              borderRadius: "12px",
                              minHeight: "56px",
                              padding: "6px 20px",
                              border: "1px solid #edebebff",
                            }}
                          >
                            <span className="fw-semibold text-pink" style={{ color: "#ff5d9b", fontSize: "16px" }}>
                              {selectedStartTime} - {endTimeShow}
                            </span>

                            {isNextDay && (
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "#ff5d9b",
                                  fontWeight: 600,
                                  fontSize: "12px",
                                  mt: 0.5
                                }}
                              >
                                * Spans next day
                              </Typography>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="feature-card shadow-none p-2 mb-2 mb-md-4 d-flex align-items-center gap-4 mb-5">
                      <Grid container>
                        <Grid item xs={12} sm={4}>
                          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ color: "red", marginRight: "4px" }}>*</span>
                            <Box>
                              <Typography className="field-label lh-sm pe-2 pb-2">
                                Select Provider Language
                              </Typography>
                              <Typography className="field-label pink-text pb-3">
                                (Maximum Two Languages Only)
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                          <FormControl className="w-100">
                            <InputLabel
                              id="demo-multiple-chip-label"
                              className="bg-white"
                              sx={{
                                "&.Mui-focused": {
                                  color: "#f07fa9",
                                },
                              }}
                            >
                              Select Language
                            </InputLabel>
                            <Controller
                              name={"language" as any}
                              control={control}
                              defaultValue={[] as any}
                              rules={{
                                required: "Please Select Language",
                              }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  labelId="demo-multiple-chip-label"
                                  id="demo-multiple-chip"
                                  multiple
                                  disabled={bookingDetailsShow}
                                  open={open}
                                  onOpen={() => setOpen(true)}
                                  onClose={() => setOpen(false)}
                                  sx={{
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderRadius: "12px",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#f07fa9",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#f07fa9",
                                    },
                                  }}
                                  MenuProps={{
                                    PaperProps: {
                                      style: {
                                        maxHeight: 250,
                                        width: 150,
                                        overflowY: "auto",
                                        scrollbarWidth: "thin",
                                        scrollbarColor: "#f07fa9 transparent",
                                        borderRadius: "12px",
                                        cursor: "pointer",
                                      },
                                    },
                                    anchorOrigin: {
                                      vertical: "bottom",
                                      horizontal: "left",
                                    },
                                    transformOrigin: {
                                      vertical: "top",
                                      horizontal: "left",
                                    },
                                  }}
                                  value={selectedLanguages}
                                  onChange={handleLanguageChange as any}
                                  input={
                                    <OutlinedInput
                                      id="select-multiple-chip"
                                      label="Chip"
                                    />
                                  }
                                  renderValue={(selected) => (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 0.5,
                                      }}
                                    >
                                      {selected.map((value) => (
                                        <Chip
                                          key={value}
                                          label={value}
                                          onDelete={() => handleDelete(value)}
                                          onMouseDown={(e) =>
                                            e.stopPropagation()
                                          }
                                          sx={{
                                            backgroundColor: "#F475A4",
                                            color: "#ffffff",
                                            "& .MuiChip-deleteIcon": {
                                              color: "#ffffff",
                                            },
                                          }}
                                        />
                                      ))}
                                    </Box>
                                  )}
                                >
                                  {languages
                                    .filter(
                                      (lang) =>
                                        !selectedLanguages.includes(lang),
                                    )
                                    .map((name) => (
                                      <MenuItem
                                        key={name}
                                        value={name}
                                        sx={{
                                          "&.Mui-selected": {
                                            backgroundColor: "#F475A4",
                                            color: "#ffffff",
                                          },
                                          "&:hover": {
                                            backgroundColor: "#F475A4",
                                            color: "#000000",
                                          },
                                          color: "#000000",
                                        }}
                                      >
                                        {name}
                                      </MenuItem>
                                    ))}
                                </Select>
                              )}
                            />
                            <p className="text-danger">
                              {errorMsg?.selectLanguage}
                            </p>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box className="feature-card shadow-none p-2 mb-2 mb-md-4 d-flex align-items-center gap-4 mb-5">
                      <Grid container>
                        <Grid item md={4} mb={2}>
                          <Box className="gap-1" sx={{ display: "flex", alignItems: "flex-start" }}>
                            <span style={{ color: "red" }}>*</span>
                            <Box>
                              <Typography className="field-label lh-sm mb-2">
                                Number Of Service Providers
                              </Typography>
                              {isServiceProviderFixed && (
                                <Typography variant="caption" sx={{
                                  color: "#f07fa9",
                                  fontStyle: "italic",
                                  display: "block",
                                  mt: 0.5
                                }}>
                                  (Fixed to 1 provider for this service)
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item md={6}>
                          <Box className="d-flex align-items-center gap-3 ms-2">
                            {!bookingDetailsShow && !isServiceProviderFixed && (
                              <Button
                                className="control-btn p-0 bg-transparent minus-btn"
                                onClick={() => handleDecriment("count")}
                              >
                                <img
                                  src={count == 1 ? minusImg : PinkMinusImg}
                                  className=""
                                />
                              </Button>
                            )}
                            <Input
                              disabled={bookingDetailsShow || isServiceProviderFixed}
                              type="text"
                              inputMode="numeric"
                              placeholder="Give title to service"
                              className="feature-field service-provider-field count-field font-16"
                              fullWidth
                              value={count}
                              sx={{
                                backgroundColor: isServiceProviderFixed ? "#f5f5f5" : "transparent",
                                cursor: isServiceProviderFixed ? "not-allowed" : "text"
                              }}
                            />
                            {!bookingDetailsShow && !isServiceProviderFixed && (
                              <Button
                                className="control-btn p-0 bg-transparent plus-btn"
                                onClick={() => handleIncrement("count")}
                              >
                                <img src={plusImg} />
                              </Button>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={1}></Grid>
                  <Grid item xs={12} lg={6} className="mb-2 mb-md-4 ps-md-2">
                    <Box className="feature-card shadow-none p-2 mb-2 mb-md-4">
                      <Typography className="field-label mb-2">
                        <span style={{ color: "red" }}>*</span> Location
                      </Typography>

                      <LocationSelector
                        bookingDetailsShow={bookingDetailsShow}
                        placeholder="Enter Location"
                        loactionSearchData={loactionSearchData}
                        setLocationSearchData={setLocationSearchData as any}
                        setErrorMsg={setErrorMsg as any}
                        disabled={false}
                      />
                      <p className="text-danger error-text mt-2">
                        {errorMsg?.selectLocation}
                      </p>
                    </Box>

                    {/* Service-specific fields */}
                    {selectServiceName && (
                      <Box className="feature-card shadow-none p-2 mb-2 mb-md-4">
                        <Typography className="field-label lh-sm mb-2">
                          Service Details
                        </Typography>
                        <Grid container spacing={2}>
                          {(() => {
                            const serviceType = getServiceType(selectServiceName);
                            if (!serviceType) return null;

                            return fieldsConfig[serviceType].map((field) => {
                              // Cleaning type comes as ?subModality=... from the package selection
                              // page (not ?cleaningType=...). Read it directly from URL params.
                              const urlSubModality = searchParams.get('subModality');
                              const isCleaningField = field.name === 'cleaningType';
                              const isCleaningTypeLocked = isCleaningField && !!urlSubModality;

                              // Match URL value to one of the field's options (handle case diffs)
                              let fieldValue = serviceFormData[field.name] || "";
                              if (isCleaningTypeLocked) {
                                const match = field.options?.find(
                                  opt => opt.toLowerCase() === urlSubModality?.toLowerCase()
                                );
                                fieldValue = match || urlSubModality || "";
                              }

                              return (
                              <ServiceFieldRenderer
                                key={field.name}
                                field={field}
                                value={fieldValue}
                                onChange={handleServiceFieldChange}
                                disabled={
                                  bookingDetailsShow ||
                                  (isEdit && field.name === 'specialNeeds') ||
                                  isCleaningTypeLocked
                                }
                                error={serviceFieldErrors[field.name]}
                                formData={serviceFormData}
                              />
                            )});
                          })()}
                        </Grid>
                      </Box>
                    )}

                    <Box className="feature-card shadow-none p-2 mb-2 mb-md-4">
                      <Typography className="field-label mb-2">
                        <span style={{ color: "red" }}>* </span> Additional
                        Instructions{""}
                        {/* <small className="optional-text fw-bold">
                          {" "}
                          (Optional)
                        </small> */}
                      </Typography>
                      <TextField
                        disabled={bookingDetailsShow}
                        label="Additional Instructions"
                        multiline
                        rows={3}
                        fullWidth
                        value={typeadditionalInfo}
                        onChange={(event: any) => handleAdditionalInfo(event.target.value)}
                        // error={!!errorMsg.additionalInfo}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "11px",
                            paddingLeft: "14px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#ccc",
                              borderRadius: "11px",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#f07fa9",
                              borderRadius: "11px",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#f07fa9 !important",
                              borderRadius: "11px",
                            },
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#f07fa9",
                          },
                        }}
                      />

                      {errorMsg.additionalInfo && (
                        <p className="text-danger error-text mt-2">
                          {errorMsg.additionalInfo}
                        </p>
                      )}
                    </Box>

                    {/* Terms and Conditions Section */}
                    <Box className="feature-card shadow-none p-2 mb-2 mb-md-4">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={termsAccepted}
                            onChange={(e) => {
                              if (e.target.checked) {
                                // If user checks the box without viewing terms, show modal
                                setShowTermsModal(true);
                              } else {
                                setTermsAccepted(false);
                              }
                            }}
                            sx={{
                              color: '#f07fa9',
                              '&.Mui-checked': {
                                color: '#f07fa9',
                              },
                            }}
                          />
                        }
                        label={
                          <Typography variant="body2">
                            I agree to the{' '}
                            <Button
                              onClick={() => setShowTermsModal(true)}
                              sx={{
                                color: '#f07fa9',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                p: 0,
                                minWidth: 'auto',
                                '&:hover': {
                                  backgroundColor: 'transparent',
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              Terms and Conditions
                            </Button>
                          </Typography>
                        }
                      />
                      {/* {!termsAccepted && (
                        <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
                          You must accept the terms and conditions to proceed
                        </Typography>
                      )} */}
                    </Box>

                    {/* <Box className="feature-card shadow-none p-2 position-relative">
                      <Typography className="field-label mb-1">
                        <span style={{ color: "red" }}>* </span>Add Photo{" "}
                        <small className="optional-text fw-bold">
                          {" "}
                          (Optional)
                        </small>
                      </Typography>
                      <Typography className="field-label mb-3">
                        <small className="optional-text mb-2">
                          (Only JPEG, JPG, PNG File Formats are
                          allowed.)
                        </small>
                      </Typography>
                      <FileUpload
                        base64ToFile={base64ToFile}
                        uploadImageArray={imagesArray}
                        handleFile={() => {}}
                        setImageIndexCheck={() => {}}
                        reapeatImage={postDetails?.attachment || []}
                        bookingDetailsShow={bookingDetailsShow}
                        resetImages={resetImages} 
                        onResetComplete={() => setResetImages(false)}
                        error={!!errorMsg.photos}
                      />
                      {errorMsg.photos && (
                        <p className="text-danger error-text mt-2">
                          {errorMsg.photos}
                        </p>
                      )}

                    </Box> */}
                    <Box className="p-2">
                      <Button
                        className="view-profile"
                        type="submit"
                        sx={{
                          animation: 'pulseSubmit 2s infinite',
                          '@keyframes pulseSubmit': {
                            '0%': { transform: 'scale(1)', boxShadow: '0 4px 12px rgba(244, 117, 164, 0.2)' },
                            '50%': { transform: 'scale(1.05)', boxShadow: '0 8px 20px rgba(244, 117, 164, 0.4)' },
                            '100%': { transform: 'scale(1)', boxShadow: '0 4px 12px rgba(244, 117, 164, 0.2)' },
                          }
                        }}
                      >
                        {bookingDetailsShow ? "Next" : "Submit"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Style.Overview>

          {/* Special Needs Modal */}
          <Dialog
            open={showSpecialNeedsModal}
            onClose={handleModalCanceled}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle sx={{
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #e0e0e0',
              fontWeight: 'bold',
              color: '#333'
            }}>
              Special Needs Assistance Required
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Thank you for sharing your specific requirements with us. Our administration team has been notified, and we'll be reaching out to you soon to ensure your needs are accommodated in the best possible way.
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                Click "OK" to continue with your booking.
              </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 3, gap: 2 }}>
              <Button
                onClick={handleModalCanceled}
                variant="outlined"
                sx={{
                  borderColor: '#f07fa9',
                  color: '#f07fa9',
                  '&:hover': {
                    borderColor: '#d06a94',
                    backgroundColor: 'rgba(240, 127, 169, 0.04)'
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSendNotification}
                disabled={isNotifying}
                variant="contained"
                sx={{
                  backgroundColor: '#f07fa9',
                  '&:hover': {
                    backgroundColor: '#d06a94'
                  },
                  minWidth: '100px'
                }}
              >
                {isNotifying ? <CircularProgress size={24} style={{ color: "#fff" }} /> : 'OK'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Terms and Conditions Modal */}
          <Dialog
            open={showTermsModal}
            onClose={() => setShowTermsModal(false)}
            maxWidth="md"
            fullWidth
            scroll="paper"
            sx={{
              '& .MuiDialog-paper': {
                maxHeight: '80vh'
              }
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #e0e0e0',
              fontWeight: 'bold',
              color: '#333',
              textAlign: 'center'
            }}>
              Terms and Conditions - {selectServiceName || 'Service'}
            </DialogTitle>

            <DialogContent sx={{ mt: 2, maxHeight: '60vh', pb: 2 }}>
              {/* Service Specific Terms - Plain Text */}
              {selectServiceName && serviceTermsConfig[getServiceType(selectServiceName) as ServiceType] && (
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h6" sx={{ mb: 3, color: '#f07fa9', fontWeight: 'bold' }}>
                    {serviceTermsConfig[getServiceType(selectServiceName) as ServiceType].title}
                  </Typography>
                  {serviceTermsConfig[getServiceType(selectServiceName) as ServiceType].content.map((section: any, sectionIndex: number) => (
                    <Box key={sectionIndex} sx={{ mb: 3 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 'bold',
                          color: '#333',
                          mb: 1,
                          borderBottom: '2px solid #f07fa9',
                          pb: 0.5
                        }}
                      >
                        {section.section}
                      </Typography>
                      <Box sx={{ pl: 1 }}>
                        {section.items.map((item: string, itemIndex: number) => (
                          <Typography
                            key={itemIndex}
                            variant="body2"
                            sx={{
                              mb: 1.5,
                              lineHeight: 1.6,
                              textAlign: 'justify'
                            }}
                          >
                            {item}
                          </Typography>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}

              <Box sx={{
                mt: 4,
                p: 2,
                backgroundColor: '#fff3f7',
                border: '1px solid #f07fa9',
                borderRadius: '8px'
              }}>
                <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#666' }}>
                  By clicking "Accept & Continue", you acknowledge that you have read, understood, and agree to be bound by all the terms and conditions above.
                </Typography>
              </Box>
            </DialogContent>

            <DialogActions sx={{ p: 3, gap: 2, borderTop: '1px solid #e0e0e0' }}>
              <Button
                onClick={() => setShowTermsModal(false)}
                variant="outlined"
                sx={{
                  borderColor: '#f07fa9',
                  color: '#f07fa9',
                  '&:hover': {
                    borderColor: '#d06a94',
                    backgroundColor: 'rgba(240, 127, 169, 0.04)'
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleAcceptTerms}
                variant="contained"
                sx={{
                  backgroundColor: '#f07fa9',
                  '&:hover': {
                    backgroundColor: '#d06a94'
                  }
                }}
              >
                Accept & Continue
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </>
  )
}

export default CreateBooking;